export default {
  banner: {
    title: "Authing makes identity management easy",
    subtitle:
      "As an excellent provider of identity management solutions, Authing will bring significant competitive advantages to enterprises in B2B, B2C, B2E or IoT scenarios: reducing development costs, improving security, and boosting production efficiency.",
  },
  security: {
    title: "High security",
    subtitle:
      'When Authing was launched, it was selected by the China Academy of Information and Communications Technology as an "Innovative Enterprise in the Field of Identity Management and Access Control in China", and was included in the "White Paper on Cyber ​​Security Industry 2019"',
    item0: "Zero bugs and zero loopholes in existing functions",
    item1: "Key management infrastructure (KMS)",
    item2: "Standard JWT token supports asymmetric encryption",
    item3: "Support RBAC / ABAC",
    item4: "Pass ISO quality system certification",
    item5: "Security partners",
  },
  performance: {
    title: "High performance",
    "item-one": {
      title:
        "The business system can flexibly expand capacity to support one billion users",
      "list-one": "Millisecond query record",
      "list-two": "Millisecond write speed",
    },
    "item-two": {
      title: "Flexible scaling across cloud infrastructure",
      "list-one": "Redundant architecture, redundant storage",
      "list-two": "No single point of failure, high reliability",
      "list-three":
        "One-click replication of architecture to public cloud / private cloud / private cloud",
      "list-four": "One-click expansion",
      "list-five": "Visual management tools",
    },
  },
  productive: {
    title: "High productivity",
    "item-one": {
      title: "Cross platform",
      subtitle: "Millisecond query record.",
    },
    "item-two": {
      title: "Massive interface",
      subtitle: "RESTful, GraphQL, SDK.",
    },
    "item-three": {
      title: "Document",
      subtitle: "Interactive, User-Centered, Comprehensive documentation.",
    },
    "item-four": {
      title: "Serverless",
      subtitle: "Tencent Cloud, Alibaba cloud, AWS.",
    },
    "item-five": {
      title: "Multiprotocol",
      subtitle: "OAuth 2.0, OIDC, SAML, AD/LDAP, WS-Fed.",
    },
    "item-six": {
      title: "Elegant identity",
      subtitle:
        "User growth, permission control, SQL or code level data query, log, audit.",
    },
    "item-seven": {
      title: "High scalability",
      subtitle:
        "Plug in, pipeline pipeline, domain name, unlimited custom login box (style / layout), multi database compatibility.",
    },
    "item-eight": {
      title: "Zero manual deployment",
      subtitle: "Volume deployment, automatic update.",
    },
  },
  extend: {
    title: "No supplier lock-in",
    "item-one": {
      title: "Export data",
      content:
        "Authing provides a complete and easy data export feature that allows users to completely migrate their data from the platform at any time. Authing does not retain any of the data of users.",
    },
    "item-two": {
      title: "Standard protocols",
      content:
        "Authing supports all major protocols in the market such as OIDC, SAML, OAuth, etc., so customers are free to choose.",
    },
    "item-three": {
      title: "Customization process",
      content:
        "Authing supports a custom authentication process (Pipeline), customers can change the authentication process, plug and unplug the required functions, such as the invitation code registration logic, delete the module that requires dynamic verification and login, etc.",
    },
  },
  developer: {
    title: "Developer-friendly",
    "descript-one": {
      content:
        "With 700+ open interfaces, Authing supports RESTful and GraphQL. and Python, JavaScript, Node, PHP, Java, Swift. programming languages and frameworks such as Rust for Web, iOS, Android, or other back-end platforms. Authing fully supports the Serverless architecture, with and without the Serverless security-compatible OIDC framework enables secure single sign-on and authentication. cross-platform and user-friendly SDK support. ",
      link: "get more",
    },
    "descript-two": {
      content:
        "Authing is compatible with important open source software such as Oddo WordPress c9.io Strapi and reduces the workload for both enterprise and individual developers. Authing supports OAuth2.0 OIDC SAML AD/LDAP JWT, and is also the operator of the SoLiD project Asian node. ",
      link: "get more",
    },
  },
  deployment: {
    title: "Support for private deployments",
    content:
      "Authing can provide customized private deployment solutions according to the needs of the enterprise to make identity management easier. Professional technicians are involved throughout the entire process of deploying the solution and providing full customer service after the sale.",
  },
  success: {
    title: "It is our job to make sure you succeed",
    "content-one":
      "Authing supports customization and private deployment. Our team will follow up the whole process of customizing business requirements, and deploy local servers for enterprise data security and control.",
    "content-two":
      "The Customer Success team provides 7*24 hour continuous service from interface interfacing, testing and go-live to later system operation and maintenance, and management platform usage.",
  },
};
